import {useMemo} from "react";
import {RemoteValue} from "../util/RemoteValue";
import {DeskModelImpl} from "../pages/desks/DeskModel";
import {filterOfficeVisitReport} from "../util/visit/VisitReportSheetUtil";
import {filterDateRange} from "../util/FilterUtil";
import {useFloorStore} from "./FloorStore";
import {useNeighbourhoodStore} from "./NeighbourhoodStore";
import {useEmployeeVisitStore} from "./EmployeeVisitStore";
import {useResidenceStore} from "./ResidenceStore";
import {useAssignedDeskStore} from "./AssignedDeskStore";
import {DateRangeOption} from "../components/filter-fields/DateRangeFilter";
import {useWorkSiteMapStore} from "./WorkSiteMapStore";

export function useDeskModelStore(dateRange: DateRangeOption) {
    const floors = useFloorStore(state => state.remoteValue);
    const neighbourhoods = useNeighbourhoodStore(state => state.remoteValue);
    const residencyModel = useResidenceStore().remoteValue;
    const assignedDesks = useAssignedDeskStore(state => state.remoteValue);
    const workSites = useWorkSiteMapStore(state => state.remoteValue);
    const employeeVisits = useEmployeeVisitStore(state => state.remoteValue);

    return useMemo(() => RemoteValue
        .combine({floors, neighbourhoods, residencyModel, assignedDesks, workSites, employeeVisits})
        .map(({floors, neighbourhoods, residencyModel, assignedDesks, workSites, employeeVisits}) => {
                return new DeskModelImpl(
                    floors,
                    neighbourhoods,
                    residencyModel,
                    assignedDesks,
                    workSites,
                    filterOfficeVisitReport(employeeVisits, filterDateRange(dateRange))
                );
            }
        ), [floors, neighbourhoods, residencyModel, assignedDesks, workSites, employeeVisits, dateRange]
    );
}